import React, { useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import SlidingPane from 'react-sliding-pane'
import * as components from '../../components'
import * as rest from '../../services'
import OptionsForm from './OptionsForm'
import { connect } from 'react-redux'

const AddOptionsFormPane = ({ OnSuccess, title, selectedType }) => {
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  const [errors, setErrors] = useState(null)
  const [success, setSuccess] = useState(null)

  const onCreateOrUpdate = (data) => {
    const payload = []
    data.items.forEach((element) => {
      let obj = { ...data }
      Object.keys(element).forEach((key) => {
        obj[key] = element[key]
      })
      payload.push(obj)
    })

    const promise = new rest.ListService().makePostRequest(payload)
    promise
      .then((response) => {
        setSuccess(response)
        OnSuccess()
      })
      .catch((errors) => {
        setErrors(errors.response ? errors.response.data : errors)
      })
  }

  const OptionFormWithData = connect((state) => ({
    initialValues: { list_name: selectedType },
  }))(OptionsForm)

  return (
    <>
      <ReactBootstrap.Button
        variant="dark"
        size="sm"
        onClick={() => setIsPaneOpen(true)}
      >
        {components.ICONS.PLUS} {title ? title : ''}
      </ReactBootstrap.Button>

      <SlidingPane
        overlayClassName="on-top"
        isOpen={isPaneOpen}
        title="Add New Options"
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >
        {success ? (
          <components.SuccessDisplay message="Options Created successfully" />
        ) : (
          ''
        )}
        {errors ? (
          <components.ErrorDisplay error={JSON.stringify(errors)} />
        ) : (
          ''
        )}

        <OptionFormWithData onSubmit={onCreateOrUpdate} />
      </SlidingPane>
    </>
  )
}

export default AddOptionsFormPane
